import {FC} from 'react'
import clsx from 'clsx'

export type DashboardChartMetric = 'revenue' | 'transaction' | 'item' | 'customer'

const TAB_LABELS: Record<DashboardChartMetric, string> = {
  revenue: 'Sales',
  transaction: 'Transaction',
  item: 'Item',
  customer: 'Customer',
}

type Props = {
  subtitle: 'Monthly' | 'Outlet'
  metric: DashboardChartMetric
  onMetricChange: (m: DashboardChartMetric) => void
}

const METRICS: DashboardChartMetric[] = ['revenue', 'transaction', 'item', 'customer']

const DashboardChartCardHeader: FC<Props> = ({subtitle, metric, onMetricChange}) => {
  return (
    <div className='card-header border-0 pt-5'>
      <h3 className='card-title align-items-start flex-column'>
        <span className='card-label fw-bold text-gray-900'>Sales</span>
        <span className='text-muted mt-1 fw-semibold fs-7'>{subtitle}</span>
      </h3>
      <ul
        className='nav nav-stretch nav-pills nav-pills-custom d-flex'
        role='tablist'
      >
        {METRICS.map((m) => (
          <li key={m} className='nav-item p-0 ms-0 me-8' role='presentation'>
            <a
              role='tab'
              aria-selected={metric === m}
              className={clsx(
                'nav-link btn btn-color-muted px-0',
                metric === m && 'active'
              )}
              onClick={(e) => {
                e.preventDefault()
                onMetricChange(m)
              }}
              href='#'
            >
              <span
                className={clsx(
                  'fw-semibold fs-6',
                  metric === m ? 'text-primary' : 'text-muted'
                )}
              >
                {TAB_LABELS[m]}
              </span>
              <span className='bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded' />
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export {DashboardChartCardHeader, TAB_LABELS}
